module.exports = __webpack_public_path__ + "img/smooth.ab50a8e2.png";